import React from 'react';
import Close from '../../../public/images/icon-close-white.png';

export const SelectionWarningBox = ({
  limit = 1,
  handleCloseSelectionError,
}) => (
  <div className="selection-warning">
    <div className="d-flex justify-content-end">
      <img src={Close} style={{ width: '13.19px', height: '13.19px', marginBottom: '5px' }} alt="close button" onClick={handleCloseSelectionError} />
    </div>
    <p className="text-white fs-14 lh-20 mb-0">
      You can select a maximum of
      {' '}
      {limit}
      {' '}
      fundraiser only. Please deselect other fundraiser to select more
    </p>
  </div>
);
 
export default SelectionWarningBox;
